import { IActivityState } from './IState'

export const initialState: IActivityState = {
    loading: false,
    list: [],
}
